export const d2024 = {
  "item": [
    {
      "dateKind": "01",
      "dateName": "1월1일",
      "isHoliday": "Y",
      "locdate": 20240101,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20240209,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20240210,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20240211,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일(설날)",
      "isHoliday": "Y",
      "locdate": 20240212,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "삼일절",
      "isHoliday": "Y",
      "locdate": 20240301,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "국회의원선거",
      "isHoliday": "Y",
      "locdate": 20240410,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "어린이날",
      "isHoliday": "Y",
      "locdate": 20240505,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일(어린이날)",
      "isHoliday": "Y",
      "locdate": 20240506,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "부처님오신날",
      "isHoliday": "Y",
      "locdate": 20240515,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "현충일",
      "isHoliday": "Y",
      "locdate": 20240606,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "광복절",
      "isHoliday": "Y",
      "locdate": 20240815,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20240916,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20240917,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20240918,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "개천절",
      "isHoliday": "Y",
      "locdate": 20241003,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "한글날",
      "isHoliday": "Y",
      "locdate": 20241009,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "기독탄신일",
      "isHoliday": "Y",
      "locdate": 20241225,
      "seq": 1
    }
  ]
};

export const d2025 = {
  "item": [
    {
      "dateKind": "01",
      "dateName": "1월1일",
      "isHoliday": "Y",
      "locdate": 20250101,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20250128,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20250129,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "설날",
      "isHoliday": "Y",
      "locdate": 20250130,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "삼일절",
      "isHoliday": "Y",
      "locdate": 20250301,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일",
      "isHoliday": "Y",
      "locdate": 20250303,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "어린이날",
      "isHoliday": "Y",
      "locdate": 20250505,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "부처님오신날",
      "isHoliday": "Y",
      "locdate": 20250505,
      "seq": 2
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일",
      "isHoliday": "Y",
      "locdate": 20250506,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "현충일",
      "isHoliday": "Y",
      "locdate": 20250606,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "광복절",
      "isHoliday": "Y",
      "locdate": 20250815,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "개천절",
      "isHoliday": "Y",
      "locdate": 20251003,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20251005,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20251006,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "추석",
      "isHoliday": "Y",
      "locdate": 20251007,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "대체공휴일",
      "isHoliday": "Y",
      "locdate": 20251008,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "한글날",
      "isHoliday": "Y",
      "locdate": 20251009,
      "seq": 1
    },
    {
      "dateKind": "01",
      "dateName": "기독탄신일",
      "isHoliday": "Y",
      "locdate": 20251225,
      "seq": 1
    }
  ]
};

export const d2026 = {
  item: [
    // 1월
    {
      dateKind: "01",
      dateName: "신정",
      isHoliday: "Y",
      locdate: 20260101,
      seq: 1
    },

    // 2월 설날 연휴 (16~18일)
    {
      dateKind: "01",
      dateName: "설날",
      isHoliday: "Y",
      locdate: 20260216,
      seq: 1
    },
    {
      dateKind: "01",
      dateName: "설날",
      isHoliday: "Y",
      locdate: 20260217,
      seq: 2
    },
    {
      dateKind: "01",
      dateName: "설날",
      isHoliday: "Y",
      locdate: 20260218,
      seq: 3
    },

    // 3월
    {
      dateKind: "01",
      dateName: "삼일절",
      isHoliday: "Y",
      locdate: 20260301,
      seq: 1
    },
    // 5월
    {
      dateKind: "01",
      dateName: "어린이날",
      isHoliday: "Y",
      locdate: 20260505,
      seq: 1
    },
    {
      dateKind: "01",
      dateName: "부처님오신날",
      isHoliday: "Y",
      locdate: 20260524,
      seq: 1
    },
    // 6월
    {
      dateKind: "01",
      dateName: "현충일",
      isHoliday: "Y",
      locdate: 20260606,
      seq: 1
    },

    // 8월
    {
      dateKind: "01",
      dateName: "광복절",
      isHoliday: "Y",
      locdate: 20260815,
      seq: 1
    },
    // 9월 추석 연휴 (24~26일)
    {
      dateKind: "01",
      dateName: "추석",
      isHoliday: "Y",
      locdate: 20260924,
      seq: 1
    },
    {
      dateKind: "01",
      dateName: "추석",
      isHoliday: "Y",
      locdate: 20260925,
      seq: 2
    },
    {
      dateKind: "01",
      dateName: "추석",
      isHoliday: "Y",
      locdate: 20260926,
      seq: 3
    },
    // 10월
    {
      dateKind: "01",
      dateName: "개천절",
      isHoliday: "Y",
      locdate: 20261003,
      seq: 1
    },
    {
      dateKind: "01",
      dateName: "한글날",
      isHoliday: "Y",
      locdate: 20261009,
      seq: 1
    },
    // 12월
    {
      dateKind: "01",
      dateName: "기독탄신일",
      isHoliday: "Y",
      locdate: 20261225,
      seq: 1
    }
  ]
};

// ── 연도별 조회 ───────────────────────────────────────────────
//
// ⚠️ 새해가 오기 전에 그 해 공휴일(dYYYY)을 추가하고 아래 HOLIDAYS_BY_YEAR 에 등록할 것.
//
// 등록되지 않은 해에는 **법정공휴일이 예약 달력에서 막히지 않는다.**
// (일요일·토요일 처리는 화면 쪽 요일 판정이 따로 하므로 그대로 동작한다)
// 원래는 공공 API 로 받아오던 값인데 호출이 되지 않아 하드코딩으로 바뀌었다.
// 서버에서 내려주도록 되돌리는 것이 근본 해결이다.

export type Holiday = {
  dateKind?: string;
  dateName?: string;
  isHoliday?: string;
  /** YYYYMMDD. 데이터에는 숫자로 들어 있고 화면은 문자열과 느슨하게(==) 비교한다 */
  locdate: number | string;
  seq?: number;
};

export type HolidayList = { item: Holiday[] };

/** 공휴일 정보가 없는 해에 쓰는 빈 값. 모양(`{ item: [] }`)을 반드시 유지한다. */
export const EMPTY_HOLIDAYS: HolidayList = { item: [] };

const HOLIDAYS_BY_YEAR: { [year: number]: HolidayList } = {
  2024: d2024,
  2025: d2025,
  2026: d2026,
};

/** 공휴일 데이터가 있는 연도 목록 (테스트·점검용) */
export const SUPPORTED_HOLIDAY_YEARS: number[] = Object.keys(HOLIDAYS_BY_YEAR).map(Number);

/**
 * 해당 연도의 공휴일 목록.
 *
 * **반드시 `{ item: [...] }` 모양으로 돌려준다.** 예전에는 예약 화면마다 이 함수를
 * 복사해 두고 초기값을 `[]`(배열)로 잡았는데, 등록되지 않은 해에는 그 배열이 그대로
 * 나가서 읽는 쪽의 `disabledDays.item.some(...)` 이 `undefined.some` 으로 터졌다.
 * 렌더 중 예외라 예약 달력이 열리는 순간 화면 전체가 사라졌다
 * (2027-01-01 00:00 부터 재현되는 상태였다).
 */
export function getRestDay(year: number): HolidayList {
  const found = HOLIDAYS_BY_YEAR[year];
  if (found === undefined) {
    console.warn(
      `[예약] ${year}년 공휴일 데이터가 없습니다. 달력에서 법정공휴일이 막히지 않습니다. ` +
        `utils/holidays.ts 에 d${year} 를 추가하세요.`,
    );
    return EMPTY_HOLIDAYS;
  }
  return found;
}
